import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class PlaceCategory {
    public readonly id: number;
    public readonly name: string;
    public readonly superCategoryName: string;
    public readonly isDestination: boolean;
    public readonly isRetailer: boolean;
    public readonly indirectlyCompetingCategories: number[];
    constructor(
        id: number,
        name: string,
        superCategoryName: string,
        isDestination: boolean,
        isRetailer: boolean,
        indirectlyCompetingCategories: number[]
    ) {
        this.id = id;
        this.name = name;
        this.superCategoryName = superCategoryName;
        this.isDestination = isDestination;
        this.isRetailer = isRetailer;
        this.indirectlyCompetingCategories = indirectlyCompetingCategories;
    }
}

export const loadPlaceCategories = (): AppThunk<Promise<PlaceCategory[]>> => async (dispatch) => {
    try {
        const query = {
            dimensions: [
                "PlaceCategory.PlaceCategoryID",
                "PlaceCategory.PlaceCategoryName",
                "PlaceCategory.SuperCategoryName",
                "PlaceCategory.IsDestination",
                "PlaceCategory.IsRetailer",
                "PlaceCategory.CompetingCategoryIds"
            ]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const placeCategories = resultSet.rawData().map(item =>
            new PlaceCategory(
                Number(item["PlaceCategory.PlaceCategoryID"]),
                String(item["PlaceCategory.PlaceCategoryName"]),
                String(item["PlaceCategory.SuperCategoryName"]),
                Boolean(item["PlaceCategory.IsDestination"]),
                Boolean(item["PlaceCategory.IsRetailer"]),
                JSON.parse((item["PlaceCategory.CompetingCategoryIds"]) ?? "[]")
            )
        );
        return placeCategories;
    } catch (error) {
        dispatch(logError("Error loading ProductCategories.", error));
        throw error;
    }
};
